// api.js or a separate file for API utilities

import PortalAlerts from "../../app/components/PortalAlerts";
import Settings from "../config/Settings";
import getUserInfo from "../core/GetTokenized";
// Assuming the base URL and any necessary headers are defined here
const BASE_URL = Settings.apiUrl;  // Replace with your actual API URL

// `UsePortalApi` function to handle API requests using the `fetch` API
export const UsePortalApi = async (endpoint, method, data = null, withAuth = false) => {
  console.log(endpoint , "abcconfig");
  const getToken = () => {
    console.log(withAuth, "item1");
    try {
      const information = getUserInfo(); // Get the user info (will resolve the promise)
      const item = JSON.parse(information); // Parse the JSON string to an object
      const token = item.token; // Extract the token
      return token;
    } catch (error) {
      console.log("Error:", error.message);
    }
  };
  
  // Call the function
  const token = getToken();

    const headers = {
      "Content-Type": "application/json",
      ...(withAuth && { Authorization: `${token || "none"}` }), // Example of token authorization
    };

    const config = {
      method: method,
      headers: headers,
      redirect: "follow",
      body: data ? JSON.stringify(data) : null, // Convert data to JSON if it's a POST request
    };

  
try{
    const response = await fetch(`${BASE_URL}/${endpoint}`, config);
    console.log(response, "abcddddd" , endpoint);
    if(response){
    if (!response.ok) {
      const errorData = response
      const errorMessage = errorData?.message || "Try Again";
      if (response?.status === 401) {
       if(endpoint !== "Patient/Appointments" && endpoint !== "Patient/TreatmentOfChoice" && endpoint!=="Patient/Condition" && endpoint !=="Patient/AllergyIntolerance" && endpoint !=="Patient/Immunization"){
        PortalAlerts("warning", "", "Session is expired. Please login again");
        localStorage.clear();
        window.location.reload();
       }

      } else if (response?.status === 503) {
        PortalAlerts("error", "", "Service currently unavailable");
      } else {
      PortalAlerts("error", "", errorMessage);
      }
    }
  } else{
    PortalAlerts("error", "", "try Again");
  }

    const responseData = await response.json(); // Parse JSON response
    return responseData; // Return the response data from the API
  } catch (error) {
    // Catch network and CORS errors here
    if (error.name === "TypeError" && error.message.includes("Failed to fetch")) {
      // CORS or network error
      PortalAlerts("error", "", "Network error or CORS issue. Please try again later.");
    } 
    // else {
    //   // Handle other errors (like JSON parsing errors)
    //   PortalAlerts("error", "", "An unexpected error occurred. Please try again.");
    // }
  }
 
};

